import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
export default function StaffNoteEditor({ note, operation, onSave, onClose }) {
  const [text, setText] = useState(
    operation === "addendum" ? "" : note.version.text,
  );
  const [events, setEvents] = useState(
    note.version.careEvents.length
      ? note.version.careEvents
      : [{ date: "", time: null }],
  );
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await onSave({
        text,
        careEvents: events.map((event) => ({
          ...event,
          time: event.time || null,
        })),
      });
      onClose();
    } catch (error) {
      setError(
        error.message ||
          "The original was not saved. Your draft is still here.",
      );
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open onClose={saving ? undefined : onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {operation === "addendum"
          ? "Add a dated correction"
          : "Edit your original note"}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Alert severity="info">
            {operation === "addendum"
              ? "The signed wording stays unchanged. This correction has its own signing state."
              : "Saving creates a new original version and reorganizes its linked moments. Confirm when the care happened."}
          </Alert>
          <TextField
            label={
              note.version.inputMode === "voice"
                ? "Transcript"
                : "Your original words"
            }
            multiline
            minRows={5}
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
          {events.map((care, index) => (
            <Stack key={index} direction="row" spacing={1}>
              <TextField
                label="Care date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={care.date}
                onChange={(event) =>
                  setEvents((items) =>
                    items.map((item, i) =>
                      i === index
                        ? { ...item, date: event.target.value }
                        : item,
                    ),
                  )
                }
              />
              <TextField
                label="Care time (optional)"
                type="time"
                InputLabelProps={{ shrink: true }}
                value={care.time || ""}
                onChange={(event) =>
                  setEvents((items) =>
                    items.map((item, i) =>
                      i === index
                        ? { ...item, time: event.target.value }
                        : item,
                    ),
                  )
                }
              />
              {events.length > 1 ? (
                <Button
                  onClick={() =>
                    setEvents((items) => items.filter((_, i) => i !== index))
                  }
                >
                  Remove date
                </Button>
              ) : null}
            </Stack>
          ))}
          <Button
            onClick={() =>
              setEvents((items) => [...items, { date: "", time: null }])
            }
            disabled={events.length >= 31}
          >
            Add another care date
          </Button>
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={save}
          disabled={
            saving || !text.trim() || events.some((event) => !event.date)
          }
        >
          {saving ? "Saving…" : "Save original"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
